import "pixi";
import "phaser";

type Sound = "slash" | "hit_ground" | "walking" | "collect_star";

export default class AudioEngine {
    static instance: AudioEngine | null = null;

    game: Phaser.Game;
    music: Phaser.Sound;
    sounds: { [key: string]: Phaser.Sound } = {};

    static initialize(game: Phaser.Game) {
        if(this.instance === null) {
            this.instance = new AudioEngine(game);
        }
    }

    static get(): AudioEngine {
        if(this.instance === null) {
            throw "AudioEngine must be initialized before it can be used";
        }
        return this.instance;
    }

    private constructor(game: Phaser.Game) {
        this.game = game;

        // Don't stop the sounds when the game pauses (i.e. loses focus)
        this.game.sound.muteOnPause = false;

        // Load the music
        this.music = this.game.add.audio("music1");
        this.music.loop = true;
        this.music.volume = 0.4;

        // Load the sound effects
        this.sounds["slash"] = this.game.add.audio("slash");
        this.sounds["slash"].volume = 0.32;
        this.sounds["slash"].loop = false;

        this.sounds["hit_ground"] = this.game.add.audio("hit_ground");
        this.sounds["hit_ground"].volume = 0.2;
        this.sounds["hit_ground"].loop = false;

        this.sounds["walking"] = this.game.add.audio("walk_roof");
        this.sounds["walking"].volume = 0.15;
        this.sounds["walking"].loop = true;

        this.sounds["collect_star"] = this.game.add.audio("collect_star");
        this.sounds["collect_star"].volume = 0.4;
        this.sounds["collect_star"].loop = false;
    }

    startMusic(): void {
        // Don't start the music if already playing
        if(this.music.isPlaying) return;

        this.music.play();
    }

    play(name: Sound, restart=true) {
        this.sounds[name].play(undefined, undefined, undefined, undefined, restart);
    }

    stop(name: Sound) {
        this.sounds[name].stop();
    }

    stopAllSounds(exceptions: Sound[] = []) {
        for(let s in this.sounds) {
            if(exceptions.some(e => e === s)) continue;
            this.sounds[s].stop();
        }
    }

    mute(): void {
        this.game.sound.mute = true;
    }

    unmute(): void {
        this.game.sound.mute = false;
    }
}



// WEBPACK FOOTER //
// ./src/audio_engine.ts